module.exports = "/_next/static/fonts/ABCSocialCondensed-Regular-416cebcfa7a52421990a175f529a3bcd.woff2";